import React from "react";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import ScreenView from "./ScreenView";

import { useTheme } from "@/providers/ThemeProvider";

/**
 * Minimum native top padding (px). Guarantees the logo clears the status bar
 * with breathing room even when the edge-to-edge safe-area inset is
 * under-reported (SE-5549). Web has no status bar, so it gets 0 and keeps its
 * className-driven top spacing.
 */
const MIN_TOP_INSET = 44;

/**
 *
 */
export interface IForm {
  mobileNumber: string;
}

/**
 *
 */
interface Props {
  title: string;
  widthContent: number;
  subTitle: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  backToSignIn?: boolean;
  isDisableButtonBack?: boolean;
}

/**
 * Container component for authentication screen layout that manages theme state
 * @param props - Component props including title, subtitle, content width, children, footer, and navigation options
 */
const ScreenContainer = (props: Props) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  // SE-5549: feed the device top inset so the logo clears the status
  // bar / notch instead of rendering under it (auth screens have no
  // SafeAreaView wrapper of their own). Guard with a native minimum in case
  // the edge-to-edge inset is under-reported; web gets 0 (no status bar).
  const { top } = useSafeAreaInsets();
  const topInset = Platform.OS === "web" ? 0 : Math.max(top, MIN_TOP_INSET);

  return <ScreenView {...props} isDark={isDark} topInset={topInset} />;
};

export default ScreenContainer;
